import React, { useState } from "react";
import {
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap";


const KotBill = ({ isOpen, toggle, kotData }) => {
  if (!kotData) return null; // Prevent errors on initial empty state
  const [isKOTOpen, setIsKOTOpen] = useState(false);
  const selectedTable = JSON.parse(localStorage.getItem("selectedTable"));

  const toggleKOT = () => setIsKOTOpen(!isKOTOpen);
  // const handlePrint = async () => {
  //   try {
  //     const response = await OrderServices.kotprint(selectedTable?.id);
  //     toast.success(response);
  //   } catch (error) {
  //     console.error("KOT print error:", error);
  //     toast.error("KOT print unsuccessful.");
  //   }
  // };
  return (
    <Modal isOpen={isOpen} toggle={toggle} scrollable>
      <ModalHeader toggle={toggle}></ModalHeader>
      <ModalBody>
        <div
          className="d-flex flex-column "
          style={{ fontFamily: "monospace", fontSize: "14px" }}
        >
          {/* Header */}
          <div className="text-center mb-2">
            <div className="fw-bold mt-1">K.O.T #{kotData?.kotNumber}</div>
          </div>

          {/* Meta Info */}
          <div className="mb-2">
            <div>
              Table: <strong>{kotData?.tableName}</strong>
            </div>
            <div>
              Ordered By: <strong>{kotData?.orderBy}</strong>
            </div>
            <div>
              Print Type: <strong>{kotData?.printType}</strong>
            </div>
          </div>

          {/* Table */}
          <Table size="sm" responsive className="table-bordered small mb-3">
            <thead>
              <tr>
                <th>SN</th>
                <th>Item</th>
                <th className="text-center">Qty</th>
                <th className="text-center">Rate</th>
              </tr>
            </thead>
            <tbody>
              {kotData?.orderDetailPrintingLogs?.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.productName}</td>
                  <td className="text-center">{item.quantity}</td>
                  <td className="text-center">{item.productPrice}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {/* {kotData?.orderDetailPrintingLogs?.map((item, index) => (
            <small key={index + 1}>
              {item?.productName}: {item?.note}
            </small>
          ))} */}
          {/* Footer Info */}
          <div className="text-small  text-center mt-3">
            Date:{" "}
            <strong>{new Date(kotData?.createdDate).toLocaleString()}</strong>
          </div>
        </div>
      </ModalBody>

      {/* <KOTModal
        isOpen={isKOTOpen}
        toggle={toggleKOT}
        handlePrint={handlePrint}
      /> */}
    </Modal>
  );
};

export default KotBill;
